/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import PropTypes from 'prop-types';
import colors from 'ui/styles/colors.module.scss';
import fontWeight from 'ui/styles/font-weights.module.scss';
import fontSize from 'ui/styles/font-sizes.module.scss';

const Text = ({
  size = Text.size.xs,
  weight = Text.weight.regular,
  className = null,
  style = null,
  children,
  ...props
}) => {
  props = {
    ...props,
    color: typeof props.color === 'undefined' ? Text.color.primary : props.color,
  };

  const getStyles = () => {
    const styles = { ...style };
    if (size) styles.fontSize = size;
    if (weight) styles.fontWeight = weight;
    return styles;
  };

  return (
    <span className={className} style={getStyles()} {...props}>
      {children}
    </span>
  );
};

Text.weight = fontWeight;
Text.size = fontSize;
Text.color = colors;

Text.propTypes = {
  className: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(), PropTypes.array]),
  children: PropTypes.node.isRequired,
  weight: PropTypes.oneOf(Object.values(Text.weight)),
  size: PropTypes.oneOf(Object.values(Text.size)),
  color: PropTypes.oneOf(Object.values(Text.color)),
};

export default Text;
